import { useParams } from 'react-router-dom';
import {useQuery} from "@tanstack/react-query";
import {  fetchTx } from '../../services';
import { Divider } from '@mui/material';

import TxFee from './components/TxFee';
import TxMessages from './components/TxMessages';
import TxOverview from './components/TxOverview';
import TxSignatures from './components/TxSignatures';
import { useContext } from 'react';
import { LabContext } from '../../context/lab';
import LoadingWrapper from '../../components/LoadingWraper';
import CopyTxtIconBtn from '../../components/CopyTxtIconBtn';
import SearchResultTitle from '../../components/SearchResultTitle';

const TransactionPage = () => {
  const {lab} = useContext(LabContext);
  const { txHash } = useParams();

  const { isLoading ,data, error, isFetching, isSuccess } = useQuery(['tx', txHash],  async () => 
      await fetchTx({txHash: txHash!, env: lab?.env}),
      {
        refetchOnWindowFocus: false, 
        retry: 3
      }
  );
    

  return (
    <div>
      <SearchResultTitle>
        Transaction: <CopyTxtIconBtn fontSize="small" value={txHash || ""}/> {txHash}
      </SearchResultTitle>
      
      <Divider />
      <LoadingWrapper
        child={
          <div>
            <TxOverview height={data?.height} />
            <TxSignatures signatures={data?.signatures} />
            <TxFee fee={data?.auth_info.fee} />    
            <TxMessages body={data?.body}/>
          </div>
        }
        isLoading = {isLoading || isFetching}
        error = {!!error}
        isSucceeded={isSuccess}
        errorTxt={`Transaction ${txHash} was not found`}
      />
    </div>
  )
}

export default TransactionPage